export const toBool = (boolString) => (boolString === "true" ? true : false);
